function getRandom(array) {
  const randomIndex = Math.floor(Math.random() * array.length)
  const item = array[randomIndex]
  return item
}

function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));

    [array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

export { getRandom, shuffle }
